import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { LoadingButton } from "./LoadingSkeleton";

const EditRecipeModal = React.memo(({
  show,
  onHide,
  editRecipeData,
  editMultiplier,
  onMultiplierChange,
  recipeOptions,
  onRecipeChange,
  dayOptions,
  courseOptions,
  onDayChange,
  onCourseChange,
  onlyUserRecipes,
  onToggleUserRecipes,
  showEditShoppingListConfirm,
  onShoppingListConfirmChange,
  onSave,
  calculateServings,
  isUpdating = false,
  currentPlanType = 'current'
}) => {
  const selectStyles = {
    option: (provided) => ({
      ...provided,
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    control: (provided, state) => ({
      ...provided,
      color: "black",
    }),
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Edit Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <Form.Switch
                type="switch"
                id="edit-only-user-recipes"
                label="Only Your Recipes"
                checked={onlyUserRecipes}
                onChange={onToggleUserRecipes}
                className="d-flex align-items-center gap-2"
              />
            </div>
          </div>
          
          <div className="row g-3 mb-3">
            <div className="col-md-3">
              <label className="form-label"><b>Multiplier</b></label>
              <input
                type="number"
                className="form-control"
                placeholder="1"
                min="0"
                value={editMultiplier}
                onChange={(e) => onMultiplierChange(e.target.value)}
              />
            </div>
            
            <div className="col-md-9">
              <label className="form-label"><b>Recipe</b></label>
              <Select
                isSearchable={true}
                options={recipeOptions}
                value={{
                  label: editRecipeData.label,
                  value: editRecipeData.value,
                  servings: editRecipeData.servings,
                }}
                onChange={onRecipeChange}
                styles={selectStyles}
                placeholder="Select a recipe..."
              />
              <small className="text-muted">
                Servings: {calculateServings(editMultiplier, editRecipeData.servings)}
              </small>
            </div>
          </div>
          
          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label className="form-label"><b>Day</b></label>
              <Select
                options={dayOptions}
                value={{
                  value: editRecipeData.dayValue,
                  label: editRecipeData.dayName,
                }}
                isSearchable
                onChange={onDayChange}
                styles={selectStyles}
              />
            </div>
            
            <div className="col-md-6">
              <label className="form-label"><b>Course</b></label>
              <Select
                options={courseOptions}
                value={{
                  value: editRecipeData.courseValue,
                  label: editRecipeData.courseName,
                }}
                isSearchable
                onChange={onCourseChange}
                styles={selectStyles}
              />
            </div>
          </div>
          
          <div className="row">
            <div className="col-12">
              {currentPlanType === 'current' ? (
                <div className="alert alert-info p-2">
                  <Form.Check
                    type="checkbox"
                    id="edit-shopping-list-confirm"
                    checked={showEditShoppingListConfirm}
                    onChange={(e) => onShoppingListConfirmChange(e.target.checked)}
                    label={
                      <span className="small">
                        <strong>Update shopping list</strong>
                        <br />
                        <span className="text-muted">
                          <strong>When checked:</strong> Shopping list items will be refreshed to match the changes
                          <br />
                          <strong>When unchecked:</strong> No items will be added or removed from the shopping list
                        </span>
                      </span>
                    }
                  />
                </div>
              ) : (
                <div className="alert alert-warning p-2">
                  <small>
                    <strong>Note:</strong> Shopping list will not be updated when editing next week's plan.
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <LoadingButton 
          variant="primary" 
          onClick={onSave} 
          isLoading={isUpdating}
          loadingText="Updating..."
        >
          Update
        </LoadingButton>
      </Modal.Footer>
    </Modal>
  );
});

export default EditRecipeModal;